module.exports = __webpack_public_path__ + "img/Logo.ed748333.png";